import { Column } from '@ant-design/charts';
import { useQuery } from '@apollo/client';
import {
  Challenge,
  GET_OPEN_CHALLENGE_APPLICATION_STAGES,
} from '@frontend/data-access';
import { Card } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

/* eslint-disable-next-line */
export interface ChallengeDashboardApplicationsProps {
  challenge: Challenge & { __typename?: string };
}

export function ChallengeDashboardApplications({
  challenge,
}: ChallengeDashboardApplicationsProps) {
  const { t } = useTranslation('common');

  const { data, loading } = useQuery<{
    challengeApplicationStages: { applications: number; stage: string }[];
  }>(GET_OPEN_CHALLENGE_APPLICATION_STAGES, {
    fetchPolicy: 'no-cache',
    variables: {
      challengeId: challenge.id,
    },
  });

  const highestStage = useMemo(() => {
    if (
      !data?.challengeApplicationStages ||
      data.challengeApplicationStages.length === 0
    ) {
      return '';
    }
    return data.challengeApplicationStages.reduce((max, item) =>
      item.applications > max.applications ? item : max
    ).stage;
  }, [data]);

  const config = {
    data: data?.challengeApplicationStages || [],
    loading: loading,
    xField: 'stage',
    yField: 'applications',
    colorField: 'stage',
    color: ({ stage }: { stage: string }) =>
      stage === highestStage ? '#63E063' : '#58AFFF',
    label: false,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
        offset: 10,
        rotate: -45,
        style: {
          fontFamily: 'Lufga',
          fill: 'rgba(0, 0, 0, 0.65)',
          textAlign: 'right',
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fontFamily: 'Lufga',
        },
      },
    },
    legend: {
      position: 'bottom',
      flipPage: false,
    },
  };

  return (
    <Card style={{ borderRadius: 20 }}>
      <div className="mb-5">
        <h2>{t('application_stages')}</h2>
      </div>
      <Column key="institutions-by-region" {...config} />
    </Card>
  );
}
export default ChallengeDashboardApplications;
